const SugarDate = require('sugar/date')
import { swePnr } from '@/utils/validators'

const RulesMixin = {
  data: () => ({
    rules: {
      notEmpty: value => (Array.isArray(value) && value.length > 0) || 'Måste anges.',
      required: value => Boolean(value) || 'Måste anges.',
      requiredIf: (condition, value) => (!condition || (condition && ((Boolean(value)) || (value.length && value.length > 0)))) || 'Måste anges.',
      pwdLength: value => (!value || value.length >= 8) || 'Minst 8 tecken.',
      pwdMatch: (v1, v2) => v1 === v2 || 'Måste matcha lösenord.',
      integer: value => (!value || Number.isInteger(Number.parseInt(value))) || 'Får bara innehålla siffror.',
      number: value => (!value || !isNaN(value)) || 'Får bara innehålla siffror.',
      orgnr: value => {
        return (!value || (value.length && value.length === 11)) || 'Måste vara 10 tecken lång.'
      },
      hasLength: (len, value) => (!value || (value.length && value.length === len)) || 'Måste vara ' + len + ' tecken lång.',
      swePnr: value => (!value || swePnr(value)) || 'Matchar inte ett svenskt personnummer.',
      phone: value => {
        const pattern = /^([+](\d{1,3})\s?)?((\(\d{3,5}\)|\d{2,5})([\s-]*)?)\d{5,9}$/
        return (!value || pattern.test(value)) || 'Felaktigt telefonnummer'
      },
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return (!value || pattern.test(value)) || 'Felaktig e-postadress.'
      },
      dateDiff: (v1, v2) => v1 > v2 || 'Slutdatum kan inte vara före startdatum',
      notMinor: (value = '') => {
        const birthDate = SugarDate.Date(String(value).slice(0, 8));
        const age = birthDate.yearsAgo();
        return ((!value) || age >= 18) || 'Personen du försöker skapa är minderårig och kan enbart skapas av BYN kansliet, var vänlig kontakta BYN kansliet för hjälp i ärendet.'
      },
      isMinor: (value = '') => {
        const birthDate = SugarDate.Date(String(value).slice(0, 8));
        const age = birthDate.yearsAgo();
        return age < 18
      }
    }
  })
}

export default RulesMixin
